import React, { useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import { mitigatorActions } from "../../../store/";
import "./style.scss";

export const MitigatorRiskHomeScreen = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(mitigatorActions.fetchAssetTypeList());
    dispatch(mitigatorActions.fetchAssetList());
    dispatch(mitigatorActions.fetchThreats());
    dispatch(mitigatorActions.fetchSources());
    dispatch(mitigatorActions.fetchVulnerabilities());
  }, []);
  return <Fragment>{props.children}</Fragment>;
};
